export default {"src":"/_next/static/media/yellowCheckbox.0ad51d42.svg","height":21,"width":19,"blurWidth":0,"blurHeight":0};